import React, { Component, Fragment } from 'react';
import ListAccounts from "./ListAccounts";
import { Route, Routes } from "react-router-dom";
import RoutePaths from "../../utils/RoutePaths";
import CreateAccount from "./CreateAccount";
import AccountDetails from "./AccountDetails";

// Helper to get relative path from full path
const getRelativePath = (fullPath) => fullPath.replace(/^\/admin\/accounts\/?/, '') || '/';

class Accounts extends Component {
    render() {
        return (
            <Fragment>
                <Routes>
                    <Route path={getRelativePath(RoutePaths.createAccounts)} element={<CreateAccount />} />
                    <Route path={getRelativePath(RoutePaths.editAccount)} element={<CreateAccount />} />
                    <Route path={getRelativePath(RoutePaths.getAccount) + "/:acctName"} element={<AccountDetails />} />
                    <Route path={getRelativePath(RoutePaths.listAccounts)} element={<ListAccounts />} />
                    <Route path={getRelativePath(RoutePaths.defaultAccounts)} element={<ListAccounts />} />
                </Routes>
            </Fragment>
        );
    }
}

export default Accounts;